/**
 * @Description
 */
/** table内数据请求参数 */
export interface FiftersType {
	tab: number; // 顶部tab
	isRead?: number; // 消息tab是否已读
	keyword?: string; // 搜索关键词
  typeValueIdList?: number[];
  statusIdList?: number[];
}

/** 工作台消息tab数量 */
export interface TabCountType {
	itoDoCount: number; // 待处理
	ihaveDoneCount: number; // 已处理的
	isponsorCount: number; // 我发起的
	msgCount: number; // 消息数量
  iccCount:number;// 抄送我的
  ccUnreadCount:number;// 抄送未读个数
	permissions?: PermissionsType[];
}
/** 权限配置 */
export interface PermissionsType {
	event: string;
	name: string;
};

/** 审批工作台tab枚举值 */
export enum WORKBENCH_TABS_ENUMS {
	/** 待我处理 */
	WAITING_DISPOSE = '1',
	/** 我发起的*/
	MY_APPROVE = '2',
	/** 已处理 */
	HAS_SOLVED = '3',
  /** 抄送我的 */
	COPY = '4',
}

/** 审批状态枚举值 */
export enum APPROVE_STATUS_ENUMS {
	/** 待处理 */
	WAITING_DISPOSE = 0,
	/** 审核通过 */
	APPROVE_ACCESS = 1,
	/** 审核拒绝 */
	APPROVE_REFUSE = 2,
	/** 审核撤销 */
	APPROVE_REVOCATION = 3,
	/** 审核驳回 */
	APPROVE_REJECT = 4,
}

/** 状态颜色值 */
export const statusColor = {
  [APPROVE_STATUS_ENUMS.WAITING_DISPOSE]: '#FF861D',
  [APPROVE_STATUS_ENUMS.APPROVE_ACCESS]: '#009963',
  [APPROVE_STATUS_ENUMS.APPROVE_REFUSE]: '#F53F3F',
  [APPROVE_STATUS_ENUMS.APPROVE_REJECT]: '#F53F3F',
};

// /** 审批工作台权限配置 */
// export enum APPROVE_BUTTON_TYPE {
//   // 审批者角度
//   /** 加签*/
// 	ADD_APPROVE = 'addApproval',
//   /** 转交*/
// 	TRANSFER = 'transfer',
// 	/** 通过 */
// 	PASS = 'pass',
// 	/** 不通过*/
// 	NO_PASS = 'reject',

//   // 发起人角度

// 	/* 撤回*/
// 	REVOKE = 'revoke',
// 	/** 提交审批*/
// 	SUBMIT = 'submit',
// }
